import { NgIf } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [NgIf],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  show = false;
  message = '';
  typeClass = 'toast-info';

  constructor() { }

  ngOnInit(): void {
  }

  showToast(message: string, type: string = 'info', duration: number = 3000): void {
    this.message = message;
    this.typeClass = `toast-${type}`;
    this.show = true;

    setTimeout(() => {
      this.hideToast();
    }, duration);
  }

  hideToast(): void {
    this.show = false;
  }
}
